import {isOlVersion} from '../../constants'

export default function isNeedToSendUserEvents() {
    return isOlVersion
}



// WEBPACK FOOTER //
// ./web/js/userEvents/checks/isNeedToSendUserEvents.js